import { useMutation, useQueryClient } from '@tanstack/react-query';
import { saveOwner } from '@Services/api/businessOwner';
import { getBusinessOwnersQueryKey } from '@Pages/happyFlowPages/ownersCenter/api/ownersCenter.api';

type SaveOwnerOnSuccess = Parameters<
  typeof useMutation<
    Awaited<ReturnType<typeof saveOwner>>,
    Error,
    Parameters<typeof saveOwner>[0],
    unknown
  >
>[0]['onSuccess'];

interface UseSaveOwnerParams {
  onSuccess?: SaveOwnerOnSuccess;
  customerId: string;
  businessExternalId: string;
  isEmbedded: boolean;
}
export const useSaveOwner = ({
  onSuccess,
  customerId,
  businessExternalId,
  isEmbedded,
}: UseSaveOwnerParams) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: saveOwner,
    onSuccess: (...args) => {
      queryClient.invalidateQueries({
        queryKey: getBusinessOwnersQueryKey({ customerId, businessExternalId, isEmbedded }),
      });
      onSuccess?.(...args);
    },
  });
};
